import { Badge, Box, chakra, Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatSelfIpoMoneyAmount } from './selfIpoUtils';

interface Props {
  offering: SelfIpoOffering;
  onClick: () => void;
}

const ShortSelfIpoGridItem: FC<Props> = ({ offering, onClick, ...props }) => {
  const { t } = useTranslation();
  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.35)';

  return (
    <AppCard
      overflow="hidden"
      cursor="pointer"
      h="230px"
      p="20px"
      position="relative"
      bgColor={Color.Shade600}
      onClick={onClick}
      {...props}
    >
      {offering.coverImageUrl && (
        <Box
          position="absolute"
          inset="0"
          bgImage={`url(${offering.coverImageUrl})`}
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
        />
      )}
      <Box
        position="absolute"
        inset="0"
        bg="linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.62) 100%)"
      />
      <Badge
        position="absolute"
        top="14px"
        right="14px"
        borderRadius="16px"
        px="12px"
        py="4px"
        color={Color.Primary500}
        bg="rgba(0, 0, 0, 0.36)"
        fontSize="11px"
        textTransform="none"
      >
        {offering.isAccepting
          ? t('selfIpoCardOpenStatus')
          : t('selfIpoCardClosedStatus')}
      </Badge>
      <Flex
        h="100%"
        position="relative"
        zIndex={1}
        flexDir="column"
        justifyContent="flex-end"
      >
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={800}
          fontSize="22px"
          lineHeight="1.12"
          noOfLines={3}
        >
          {offering.companyName}
        </Text>
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={600}
          fontSize="16px"
          mt="8px"
          noOfLines={1}
        >
          ${formatSelfIpoMoneyAmount(offering.priceLow)}-$
          {formatSelfIpoMoneyAmount(offering.priceHigh)}
        </Text>
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={600}
          fontSize="15px"
          lineHeight="1.2"
          mt="4px"
          noOfLines={2}
        >
          {t('selfIpoDeadlineShort', {
            date: moment(offering.acceptanceDeadline).format('DD.MM HH:mm'),
          })}
        </Text>
      </Flex>
    </AppCard>
  );
};

export default chakra(ShortSelfIpoGridItem);
